/**
 *
 * @param rule
 */
export function getCreatureGroupId(rule) {
    return rule.creatureGroupId;
}
/**
 *
 * @param rule
 */
export function getLevelDivisor(rule) {
    return rule.levelDivisor;
}
/**
 *
 * @param rule
 */
export function getMaxChallengeRatingId(rule) {
    return rule.maxChallengeRatingId;
}
/**
 *
 * @param rule
 */
export function getMonsterIds(rule) {
    var _a;
    return (_a = rule.monsterIds) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param rule
 */
export function getMonsterTypeId(rule) {
    return rule.monsterTypeId;
}
/**
 *
 * @param rule
 */
export function getMovementIds(rule) {
    var _a;
    return (_a = rule.movementIds) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param rule
 */
export function getSizeIds(rule) {
    var _a;
    return (_a = rule.sizeIds) !== null && _a !== void 0 ? _a : [];
}
/**
 *
 * @param rule
 */
export function getContextLevelChallengeMax(rule) {
    return rule.contextLevelChallengeMax;
}
/**
 *
 * @param rule
 */
export function getMaxChallengeInfo(rule) {
    return rule.maxChallengeInfo;
}
/**
 *
 * @param rule
 */
export function getMaxChallengeValue(rule) {
    return rule.maxChallengeValue;
}
/**
 *
 * @param rule
 */
export function getDataOrigin(rule) {
    return rule.dataOrigin;
}
